export default __webpack_public_path__ + "static/step-4-34d43586b3579f35a1c3942449f12b89.png";